export default "__VITE_ASSET__12ce4f28__"